import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';

export const getTicketUppyInstance = () => {
	const uppy = new Uppy({
		restrictions: {
			maxNumberOfFiles: 5,
			allowedFileTypes: [
				'video/*', // All video file types
				'image/*', // All image file types
			],
		},
		locale: {
			strings: {
				myDevice: `Camera or Files`,
			},
		},
		meta: {
			is_public: 'true',
		},
	})
		.use(XHRUpload, {
			endpoint: '/api3.2/bucket/upload',
			fieldName: 'file',
			formData: true,
		})
		.on('file-added', (file) => {
			if (file.name.startsWith('image.')) {
				const currentTimestamp = Date.now();
				const fileExtension = file.name.split('.').pop();
				const newName = `image_${currentTimestamp}.${fileExtension}`;
				file.meta.name = newName;
				uppy.setFileState(file.id, {
					name: newName,
				});
			}
		});
	// onComplete is added in ActiveVehicleProvider.tsx. We add a onFileUploadSuccess function to handle the file upload success event.
	return uppy;
};
